var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarouselArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.8955,
    cy: 16.8682,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7753 18.3263L16.2092 25.5198C15.9412 25.8134 15.8125 26.156 15.8232 26.5474C15.834 26.9389 15.9738 27.2815 16.2427 27.5751C16.5107 27.8442 16.8233 27.9852 17.1807 27.9979C17.538 28.0106 17.8507 27.8697 18.1187 27.5751L26.9628 17.8859C27.0968 17.7391 27.192 17.5801 27.2483 17.4088C27.3045 17.2375 27.3318 17.054 27.33 16.8583C27.33 16.6626 27.3019 16.479 27.2456 16.3078C27.1893 16.1365 27.095 15.9775 26.9628 15.8307L18.1187 6.14151C17.873 5.87236 17.5657 5.73779 17.1968 5.73779C16.8278 5.73779 16.5098 5.87236 16.2427 6.14151C15.9747 6.43512 15.8407 6.78402 15.8407 7.18823C15.8407 7.59243 15.9747 7.94085 16.2427 8.23348L22.7753 15.3902H7.80054C7.42087 15.3902 7.10239 15.5312 6.84511 15.813C6.58782 16.0949 6.45963 16.4433 6.46052 16.8583C6.46052 17.2742 6.58916 17.6231 6.84645 17.905C7.10373 18.1869 7.42176 18.3273 7.80054 18.3263H22.7753Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselArrow);
export default __webpack_public_path__ + "static/media/carouselArrow.d986dec59257b6d9202c6d9241af71be.svg";
export { ForwardRef as ReactComponent };